/* tslint:disable */
/* eslint-disable */
/**
 * CMS
 * The CMS API description
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { AxiosResponse, AxiosInstance, AxiosRequestConfig } from "axios";
// @ts-ignore
import globalAxios from "@/config/axiosInstance";
import { Configuration } from "../configuration";
// Some imports not used depending on template conditions
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  RequestArgs,
  BaseAPI,
  RequiredError,
} from "../base";
/**
 * CinemaTicketApi - axios parameter creator
 * @export
 */
export const CinemaTicketApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @param {string} description
     * @param {string} slug
     * @param {string} name
     * @param {number} expireTime
     * @param {number} amount
     * @param {number} discount
     * @param {any} content
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cinemaTicketControllerCreateTicketForm: async (
      description: string,
      slug: string,
      name: string,
      expireTime: number,
      amount: number,
      discount: number,
      content: any,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'description' is not null or undefined
      if (description === null || description === undefined) {
        throw new RequiredError(
          "description",
          "Required parameter description was null or undefined when calling cinemaTicketControllerCreateTicketForm."
        );
      }
      // verify required parameter 'slug' is not null or undefined
      if (slug === null || slug === undefined) {
        throw new RequiredError(
          "slug",
          "Required parameter slug was null or undefined when calling cinemaTicketControllerCreateTicketForm."
        );
      }
      // verify required parameter 'name' is not null or undefined
      if (name === null || name === undefined) {
        throw new RequiredError(
          "name",
          "Required parameter name was null or undefined when calling cinemaTicketControllerCreateTicketForm."
        );
      }
      // verify required parameter 'expireTime' is not null or undefined
      if (expireTime === null || expireTime === undefined) {
        throw new RequiredError(
          "expireTime",
          "Required parameter expireTime was null or undefined when calling cinemaTicketControllerCreateTicketForm."
        );
      }
      // verify required parameter 'amount' is not null or undefined
      if (amount === null || amount === undefined) {
        throw new RequiredError(
          "amount",
          "Required parameter amount was null or undefined when calling cinemaTicketControllerCreateTicketForm."
        );
      }
      // verify required parameter 'discount' is not null or undefined
      if (discount === null || discount === undefined) {
        throw new RequiredError(
          "discount",
          "Required parameter discount was null or undefined when calling cinemaTicketControllerCreateTicketForm."
        );
      }
      // verify required parameter 'content' is not null or undefined
      if (content === null || content === undefined) {
        throw new RequiredError(
          "content",
          "Required parameter content was null or undefined when calling cinemaTicketControllerCreateTicketForm."
        );
      }
      const localVarPath = `/v1/cms/api/cinema-ticket`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, "https://example.com");
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;
      const localVarFormParams = new FormData();

      if (description !== undefined) {
        localVarFormParams.append("description", description as any);
      }

      if (slug !== undefined) {
        localVarFormParams.append("slug", slug as any);
      }

      if (name !== undefined) {
        localVarFormParams.append("name", name as any);
      }

      if (expireTime !== undefined) {
        localVarFormParams.append("expireTime", expireTime as any);
      }

      if (amount !== undefined) {
        localVarFormParams.append("amount", amount as any);
      }

      if (discount !== undefined) {
        localVarFormParams.append("discount", discount as any);
      }

      if (content !== undefined) {
        localVarFormParams.append("content", content as any);
      }

      localVarHeaderParameter["Content-Type"] = "multipart/form-data";
      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = localVarFormParams;

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} pageNumber
     * @param {number} pageIndex
     * @param {string} [contentKey]
     * @param {string} [slug]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cinemaTicketControllerGetTicket: async (
      pageNumber: number,
      pageIndex: number,
      contentKey?: string,
      slug?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'pageNumber' is not null or undefined
      if (pageNumber === null || pageNumber === undefined) {
        throw new RequiredError(
          "pageNumber",
          "Required parameter pageNumber was null or undefined when calling cinemaTicketControllerGetTicket."
        );
      }
      // verify required parameter 'pageIndex' is not null or undefined
      if (pageIndex === null || pageIndex === undefined) {
        throw new RequiredError(
          "pageIndex",
          "Required parameter pageIndex was null or undefined when calling cinemaTicketControllerGetTicket."
        );
      }
      const localVarPath = `/v1/cms/api/cinema-ticket`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, "https://example.com");
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (pageNumber !== undefined) {
        localVarQueryParameter["pageNumber"] = pageNumber;
      }

      if (pageIndex !== undefined) {
        localVarQueryParameter["pageIndex"] = pageIndex;
      }

      if (contentKey !== undefined) {
        localVarQueryParameter["contentKey"] = contentKey;
      }

      if (slug !== undefined) {
        localVarQueryParameter["slug"] = slug;
      }

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} filename
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cinemaTicketControllerGetTicketMedia: async (
      filename: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'filename' is not null or undefined
      if (filename === null || filename === undefined) {
        throw new RequiredError(
          "filename",
          "Required parameter filename was null or undefined when calling cinemaTicketControllerGetTicketMedia."
        );
      }
      const localVarPath = `/v1/cms/api/cinema-ticket/{filename}`.replace(
        `{${"filename"}}`,
        encodeURIComponent(String(filename))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, "https://example.com");
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} description
     * @param {string} slug
     * @param {string} name
     * @param {number} discount
     * @param {number} expireTime
     * @param {number} amount
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cinemaTicketControllerUpdateTicketForm: async (
      description: string,
      slug: string,
      name: string,
      discount: number,
      expireTime: number,
      amount: number,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'description' is not null or undefined
      if (description === null || description === undefined) {
        throw new RequiredError(
          "description",
          "Required parameter description was null or undefined when calling cinemaTicketControllerUpdateTicketForm."
        );
      }
      // verify required parameter 'slug' is not null or undefined
      if (slug === null || slug === undefined) {
        throw new RequiredError(
          "slug",
          "Required parameter slug was null or undefined when calling cinemaTicketControllerUpdateTicketForm."
        );
      }
      // verify required parameter 'name' is not null or undefined
      if (name === null || name === undefined) {
        throw new RequiredError(
          "name",
          "Required parameter name was null or undefined when calling cinemaTicketControllerUpdateTicketForm."
        );
      }
      // verify required parameter 'discount' is not null or undefined
      if (discount === null || discount === undefined) {
        throw new RequiredError(
          "discount",
          "Required parameter discount was null or undefined when calling cinemaTicketControllerUpdateTicketForm."
        );
      }
      // verify required parameter 'expireTime' is not null or undefined
      if (expireTime === null || expireTime === undefined) {
        throw new RequiredError(
          "expireTime",
          "Required parameter expireTime was null or undefined when calling cinemaTicketControllerUpdateTicketForm."
        );
      }
      // verify required parameter 'amount' is not null or undefined
      if (amount === null || amount === undefined) {
        throw new RequiredError(
          "amount",
          "Required parameter amount was null or undefined when calling cinemaTicketControllerUpdateTicketForm."
        );
      }
      const localVarPath = `/v1/cms/api/cinema-ticket`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, "https://example.com");
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: "PATCH",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;
      const localVarFormParams = new FormData();

      if (description !== undefined) {
        localVarFormParams.append("description", description as any);
      }

      if (slug !== undefined) {
        localVarFormParams.append("slug", slug as any);
      }

      if (name !== undefined) {
        localVarFormParams.append("name", name as any);
      }

      if (discount !== undefined) {
        localVarFormParams.append("discount", discount as any);
      }

      if (expireTime !== undefined) {
        localVarFormParams.append("expireTime", expireTime as any);
      }

      if (amount !== undefined) {
        localVarFormParams.append("amount", amount as any);
      }

      localVarHeaderParameter["Content-Type"] = "multipart/form-data";
      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = localVarFormParams;

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * CinemaTicketApi - functional programming interface
 * @export
 */
export const CinemaTicketApiFp = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {string} description
     * @param {string} slug
     * @param {string} name
     * @param {number} expireTime
     * @param {number} amount
     * @param {number} discount
     * @param {any} content
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async cinemaTicketControllerCreateTicketForm(
      description: string,
      slug: string,
      name: string,
      expireTime: number,
      amount: number,
      discount: number,
      content: any,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<void>>
    > {
      const localVarAxiosArgs = await CinemaTicketApiAxiosParamCreator(
        configuration
      ).cinemaTicketControllerCreateTicketForm(
        description,
        slug,
        name,
        expireTime,
        amount,
        discount,
        content,
        options
      );
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {number} pageNumber
     * @param {number} pageIndex
     * @param {string} [contentKey]
     * @param {string} [slug]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async cinemaTicketControllerGetTicket(
      pageNumber: number,
      pageIndex: number,
      contentKey?: string,
      slug?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<void>>
    > {
      const localVarAxiosArgs = await CinemaTicketApiAxiosParamCreator(
        configuration
      ).cinemaTicketControllerGetTicket(
        pageNumber,
        pageIndex,
        contentKey,
        slug,
        options
      );
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {string} filename
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async cinemaTicketControllerGetTicketMedia(
      filename: string,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<void>>
    > {
      const localVarAxiosArgs = await CinemaTicketApiAxiosParamCreator(
        configuration
      ).cinemaTicketControllerGetTicketMedia(filename, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {string} description
     * @param {string} slug
     * @param {string} name
     * @param {number} discount
     * @param {number} expireTime
     * @param {number} amount
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async cinemaTicketControllerUpdateTicketForm(
      description: string,
      slug: string,
      name: string,
      discount: number,
      expireTime: number,
      amount: number,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<void>>
    > {
      const localVarAxiosArgs = await CinemaTicketApiAxiosParamCreator(
        configuration
      ).cinemaTicketControllerUpdateTicketForm(
        description,
        slug,
        name,
        discount,
        expireTime,
        amount,
        options
      );
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
  };
};

/**
 * CinemaTicketApi - factory interface
 * @export
 */
export const CinemaTicketApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  return {
    /**
     *
     * @param {string} description
     * @param {string} slug
     * @param {string} name
     * @param {number} expireTime
     * @param {number} amount
     * @param {number} discount
     * @param {any} content
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async cinemaTicketControllerCreateTicketForm(
      description: string,
      slug: string,
      name: string,
      expireTime: number,
      amount: number,
      discount: number,
      content: any,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<void>> {
      return CinemaTicketApiFp(configuration)
        .cinemaTicketControllerCreateTicketForm(
          description,
          slug,
          name,
          expireTime,
          amount,
          discount,
          content,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {number} pageNumber
     * @param {number} pageIndex
     * @param {string} [contentKey]
     * @param {string} [slug]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async cinemaTicketControllerGetTicket(
      pageNumber: number,
      pageIndex: number,
      contentKey?: string,
      slug?: string,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<void>> {
      return CinemaTicketApiFp(configuration)
        .cinemaTicketControllerGetTicket(
          pageNumber,
          pageIndex,
          contentKey,
          slug,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} filename
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async cinemaTicketControllerGetTicketMedia(
      filename: string,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<void>> {
      return CinemaTicketApiFp(configuration)
        .cinemaTicketControllerGetTicketMedia(filename, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} description
     * @param {string} slug
     * @param {string} name
     * @param {number} discount
     * @param {number} expireTime
     * @param {number} amount
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async cinemaTicketControllerUpdateTicketForm(
      description: string,
      slug: string,
      name: string,
      discount: number,
      expireTime: number,
      amount: number,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<void>> {
      return CinemaTicketApiFp(configuration)
        .cinemaTicketControllerUpdateTicketForm(
          description,
          slug,
          name,
          discount,
          expireTime,
          amount,
          options
        )
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * CinemaTicketApi - object-oriented interface
 * @export
 * @class CinemaTicketApi
 * @extends {BaseAPI}
 */
export class CinemaTicketApi extends BaseAPI {
  /**
   *
   * @param {string} description
   * @param {string} slug
   * @param {string} name
   * @param {number} expireTime
   * @param {number} amount
   * @param {number} discount
   * @param {any} content
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CinemaTicketApi
   */
  public async cinemaTicketControllerCreateTicketForm(
    description: string,
    slug: string,
    name: string,
    expireTime: number,
    amount: number,
    discount: number,
    content: any,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<void>> {
    return CinemaTicketApiFp(this.configuration)
      .cinemaTicketControllerCreateTicketForm(
        description,
        slug,
        name,
        expireTime,
        amount,
        discount,
        content,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @param {number} pageNumber
   * @param {number} pageIndex
   * @param {string} [contentKey]
   * @param {string} [slug]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CinemaTicketApi
   */
  public async cinemaTicketControllerGetTicket(
    pageNumber: number,
    pageIndex: number,
    contentKey?: string,
    slug?: string,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<void>> {
    return CinemaTicketApiFp(this.configuration)
      .cinemaTicketControllerGetTicket(
        pageNumber,
        pageIndex,
        contentKey,
        slug,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @param {string} filename
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CinemaTicketApi
   */
  public async cinemaTicketControllerGetTicketMedia(
    filename: string,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<void>> {
    return CinemaTicketApiFp(this.configuration)
      .cinemaTicketControllerGetTicketMedia(filename, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @param {string} description
   * @param {string} slug
   * @param {string} name
   * @param {number} discount
   * @param {number} expireTime
   * @param {number} amount
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CinemaTicketApi
   */
  public async cinemaTicketControllerUpdateTicketForm(
    description: string,
    slug: string,
    name: string,
    discount: number,
    expireTime: number,
    amount: number,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<void>> {
    return CinemaTicketApiFp(this.configuration)
      .cinemaTicketControllerUpdateTicketForm(
        description,
        slug,
        name,
        discount,
        expireTime,
        amount,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
}
